import classnames from 'classnames';
import React, { FC, useMemo, useEffect, useState } from 'react';
import { HttpClient } from '@wix/http-client';
import { getWixSiteMediaTokenFromFolderId } from '../../../../../../utils/media-manager-sdk/items';
import { isWixSite } from '../../../../../../utils/media-manager-sdk/sources';
import {
  isFailed as isFileFailed,
  isTranscoding as isFileTranscoding,
} from '../../../../../../utils/media-manager-sdk/transcoding';
import { ErrorOverlay, TranscodingOverlay } from '../../../../TranscodingOverlays';
import styles from '../../FileThumbnail.scss';
import { IOuter } from './AnimatedSvgThumbnail.types';
import { AnimatedSvg } from './AnimatedSvg';
import { DataHook } from './constants';

export const AnimatedSvgThumbnail: FC<IOuter> = ({
  file,
  className,
  wrapperClassName,
  dataHook = DataHook.AnimatedSvgThumbnail,
  saveRef,
}) => {
  const { isTranscoding, isFailed, siteMediaToken } = useMemo(() => {
    const { folderId, source } = file;

    return {
      isTranscoding: isFileTranscoding(file),
      isFailed: isFileFailed(file),
      siteMediaToken: isWixSite(source) ? getWixSiteMediaTokenFromFolderId(folderId) : null,
    };
  }, [file]);
  const [svgContent, setSvgContent] = useState<string | null>(null);

  useEffect(() => {
    if (file.thumbnailUrl) {
      const fetchAnimatedSvg = async () => {
        const httpClient = new HttpClient({
          getAppToken: () => siteMediaToken,
        });
        try {
          const response = await httpClient.get(file.thumbnailUrl);
          if (response.status !== 200) {
            throw new Error(`Fetch error: ${response.statusText}`);
          }
          if (!response.data) {
            throw new Error(`Fetch error: Response data is empty`);
          }
          setSvgContent(response.data);
        } catch (error) {
          console.error('Error fetching data:', error);
        }
      };
      void fetchAnimatedSvg();
    }
  }, [file.thumbnailUrl, siteMediaToken]);

  return (
    <div className={classnames(styles.thumbnailWrapper, wrapperClassName)} ref={saveRef}>
      {svgContent && (
        <AnimatedSvg
          svgContent={svgContent}
          className={classnames(styles.thumbnail, styles.picture, className)}
          dataHook={dataHook}
        />
      )}
      {isTranscoding && <TranscodingOverlay />}
      {isFailed && <ErrorOverlay />}
    </div>
  );
};
